import request from '@/utils/request'

//查看无人机点位
export const queryAllTask = (getData) => {
  return request({
    url: '/checkscreen/queryAllTask',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
//查看无人机数量
export const getDeviceCount = (getData) => {
  return request({
    url: '/checkscreen/getDeviceCount',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
//检查次数月线图
export const getCheckNumByMonth = (getData) => {
  return request({
    url: '/checkscreen/getCheckNumByMonth',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
